<template>
    <md-list-item :class="!accountBlocked ? 'active' : 'disabled' + ' account-id'" @click="toggleItem">

      <span class="settings__item-text text_large">{{ i18n.set_account_id() }}</span>
      <md-icon class="md-icon--half-sized">keyboard_arrow_right</md-icon>

      <md-dialog class="account-id__dialog settings-dialog" :md-active.sync="isDialogOpened">
        <div class="text_large">{{ i18n.set_your_account_id() }}</div>

        <div class="settings-dialog__content">
          <div class="account-id__wrapper">
            <qrcode class="qr-code account-id__qr-code"
                    :text="accountId"
                    :size="250"
                    color="#3f4244"
            />
            <clipboard-field :value="accountId"/>
          </div>
        </div>

        <div class="btn-wrap margin-top">
          <md-button type="button" class="btn md-primary" @click="isDialogOpened = !isDialogOpened">{{ i18n.lbl_cancel() }}</md-button>
        </div>
      </md-dialog>

    </md-list-item>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { i18n } from '@js/i18n'

  import ClipboardField from '@com/fields/ClipboardField'

  import Qrcode from 'vue-qrcode-component'

  export default {
    name: 'account-id',
    components: { Qrcode, ClipboardField },
    data: _ => ({
      isDialogOpened: false,
      i18n
    }),
    methods: {
      toggleItem () {
        if (!this.accountBlocked) this.isDialogOpened = !this.isDialogOpened
      }
    },
    computed: {
      ...mapGetters([
        vuexTypes.accountId,
        vuexTypes.accountBlocked
      ])
    }
  }
</script>

<style lang="scss" scoped>

  @import '~scss/mixins';
  @import './settings.scss';

  .account-id__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .account-id__qr-code {
    margin-bottom: 24px;

    @include respond-to-height(650px) {
      zoom: .5;
    }
  }

  .account-id__clipboard {
    width: calc(100% - 50px);
    margin-right: auto;

    @include respond-to(xsmall) {
      width: 100%;
    }
  }

  .account-id__content {
    @include respond-to-height(650px) {
      overflow: auto;
    }
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/settings/security/Security.AccountId.vue